<script lang="ts">
  import { isNoteName } from 'shared/definitions/musicTheory/notesAndAccidentals';
  import type { Accidental, LetterName } from 'shared/definitions/musicTheory/notesAndAccidentals';

  import Note from './note';
  import Select from '../../../website/src/lib/components/Select.svelte';
  import Option from '../../../website/src/lib/components/Option.svelte';

  export let value: Note = new Note('C4');
  export let showAccidentals: Accidental[] | false | true = ['x', '#', '', 'b', 'bb'];
  export let showOctaves = true;

  $: visibleAccidentals =
    typeof showAccidentals === 'object'
      ? showAccidentals
      : showAccidentals === true
      ? ['x', '#', '', 'b', 'bb']
      : [''];

  const letters: LetterName[] = ['C', 'D', 'E', 'F', 'G', 'A', 'B'];
  const octaves = [1, 2, 3, 4, 5, 6, 7];

  let selectedLetter: LetterName = value.letter;
  let selectedOctave = value.octave;
  let selectedAccidental = value.accidental;

  $: noteName = `${selectedLetter}${selectedAccidental}${selectedOctave}`;
  $: {
    if (isNoteName(noteName)) {
      value = new Note(noteName);
    }
  }
</script>

<div class="inline whitespace-nowrap">
  <Select class="border inline" bind:value={selectedLetter}>
    {#each letters as letter}
      <Option value={letter}>{letter}</Option>
    {/each}
  </Select>
  {#if showAccidentals}
    <Select class="border inline" bind:value={selectedAccidental}>
      {#each visibleAccidentals as accidental}
        <Option value={accidental}>{accidental}</Option>
      {/each}
    </Select>
  {/if}

  {#if showOctaves}
    <Select class="border inline" bind:value={selectedOctave}>
      {#each octaves as octave}
        <Option value={octave}>{octave}</Option>
      {/each}
    </Select>
  {/if}
</div>
